import { routes } from '@/features/v2/constants/routes';

const core = {
  bonus: {
    title: 'Redimí tus bonos aquí',
    description: 'Redimí tus bonos y disfrutá los beneficios.',
    link: routes.PROMOTIONS,
    textLink: 'Ver más',
    img: '/img/v2/home/gift.webp',
  },
  liveBets: {
    title: 'Ganancias en vivo',
    iconAlt: 'Icono de pronosticos en vivo',
    link: routes.PROMOTIONS,
    textLink: 'Filtros',
    filters: {
      highRollers: 'High Rollers',
      live: 'Ganancias en vivo',
    },
    filterDescriptions: {
      highRollers: 'Juegos con pronosticos superiores a L1,000',
      live: 'Ganancias en vivo',
    },
    img: '/img/v2/icons/Play.webp',
    table: {
      title: 'Juego',
      multiplier: 'Multiplicador',
      winnings: 'Ganancia',
    },
  },
};

export default core;
